// Tenant detection based on Host header (subdomain) with ?tenant= override for testing.
// Falls back to "default" (the EIGOO Fleet marketing portal).

export const TENANTS = {
    default: {
        id: "default",
        name: "EIGOO Fleet",
        tagline: "Silent Partners · Marketing Fleet",
        accent: "hsl(40 75% 55%)",
        accent2: "hsl(45 85% 68%)",
        modules: ["map", "boarding", "dashboard", "scout", "adkits", "subdomains"],
    },
    trade: {
        id: "trade",
        name: "EIGOO Trade",
        tagline: "Market & Liquidity Radar",
        accent: "hsl(40 75% 55%)",
        accent2: "hsl(45 85% 68%)",
        modules: ["dashboard", "scout", "subdomains"], // no ad kits / betting
    },
    sports: {
        id: "sports",
        name: "EIGOO Signal",
        tagline: "NBA & Sports Betting Signal Feed",
        accent: "hsl(40 75% 55%)",
        accent2: "hsl(45 85% 68%)",
        modules: ["dashboard", "scout", "adkits"],
    },
    cyberops: {
        id: "cyberops",
        name: "EIGOO Tech Ops",
        tagline: "Security Audit & Governance Command",
        accent: "hsl(40 75% 55%)",
        accent2: "hsl(45 85% 68%)",
        modules: ["dashboard", "scout", "subdomains"], // no adkits/boarding/betting
    },
    cyberopssa: {
        id: "cyberopssa",
        name: "EIGOO Tech Ops SA",
        tagline: "The Vault · Elite Audits & Threat Hunting",
        accent: "hsl(40 75% 55%)",
        accent2: "hsl(45 85% 68%)",
        modules: ["dashboard", "scout", "subdomains"],
    },
};

export function getTenant() {
    if (typeof window === "undefined") return TENANTS.default;

    // Query override (useful since preview hostname won't match real subdomains)
    const params = new URLSearchParams(window.location.search);
    const override = params.get("tenant");
    if (override && TENANTS[override]) {
        try { sessionStorage.setItem("eigoo_tenant_override", override); } catch (_) { /* noop */ }
        return TENANTS[override];
    }
    try {
        const stored = sessionStorage.getItem("eigoo_tenant_override");
        if (stored && TENANTS[stored]) return TENANTS[stored];
    } catch (_) { /* noop */ }

    const host = window.location.hostname.toLowerCase();
    if (host.startsWith("trade.")) return TENANTS.trade;
    if (host.startsWith("sports.")) return TENANTS.sports;
    // Order matters: cyberopssa must match before cyberops
    if (host.startsWith("cyberopssa.")) return TENANTS.cyberopssa;
    if (host.startsWith("cyberops.")) return TENANTS.cyberops;
    return TENANTS.default;
}

export function clearTenantOverride() {
    try { sessionStorage.removeItem("eigoo_tenant_override"); } catch (_) { /* noop */ }
}
